module.exports = "/_next/static/images/plus-0fd503636875e6573fb74a3fc6d08415.svg";